import { Model } from 'modules/core/lib/mobx-rest'

interface IMembership {
  id: string
  company_id: string
  employee_id: string
  team_id: string
  lead: boolean
}

class Membership extends Model<IMembership> {
  static urlRoot() {
    return '/memberships'
  }
}

export default Membership
